import { buttonsFromSerializedInAppMessage as re } from "../in-app-message-factory.js";
import InAppMessage from "./in-app-message.js";
export default class ModalMessage extends InAppMessage {
  constructor(
    e,
    r,
    s,
    t,
    i,
    o,
    a,
    p,
    m,
    n,
    u,
    c,
    d,
    f,
    l,
    g,
    j,
    v,
    x,
    z,
    h,
    w,
    y,
    S,
    b,
    k,
    q,
    A,
    B,
    C,
  ) {
    super(
      e,
      r,
      void 0,
      s,
      t,
      i,
      o,
      a,
      (p = p || InAppMessage.DismissType.MANUAL),
      m,
      n,
      u,
      c,
      d,
      f,
      l,
      g,
      j,
      v,
      x,
      z,
      h,
      w,
      y,
      S,
      (b = b || InAppMessage.CropType.FIT_CENTER),
      void 0,
      k,
      q,
      A,
      B,
      C,
    ),
      (this.zo = InAppMessage.TextAlignment.CENTER);
  }
  bt() {
    return super.bt(ModalMessage.rs);
  }
  static Xr(e) {
    return new ModalMessage(
      e[InAppMessage.hs.Vr],
      e[InAppMessage.hs.Wr],
      e[InAppMessage.hs.bs],
      e[InAppMessage.hs.Yr],
      e[InAppMessage.hs.Zr],
      e[InAppMessage.hs.URI],
      e[InAppMessage.hs.ra],
      e[InAppMessage.hs.sa],
      e[InAppMessage.hs.ta],
      e[InAppMessage.hs.ia],
      e[InAppMessage.hs.ds],
      e[InAppMessage.hs.oa],
      e[InAppMessage.hs.pa],
      e[InAppMessage.hs.ma],
      e[InAppMessage.hs.na],
      e[InAppMessage.hs.ua],
      e[InAppMessage.hs.ca],
      e[InAppMessage.hs.fa],
      e[InAppMessage.hs.da],
      e[InAppMessage.hs.la],
      e[InAppMessage.hs.ga],
      e[InAppMessage.hs.ja],
      e[InAppMessage.hs.xa],
      re(e[InAppMessage.hs.za]),
      e[InAppMessage.hs.ha],
      e[InAppMessage.hs.wa],
      e[InAppMessage.hs.CSS],
      e[InAppMessage.hs.ya],
      e[InAppMessage.hs.LANGUAGE],
      e[InAppMessage.hs.qs],
    );
  }
}
ModalMessage.rs = InAppMessage.ho.Jr;
